import { createSelector } from 'reselect';
import consts, { STATUSES } from '../data/consts';
import { selectGoogleDrive, selectListFiles, selectCurrentContext } from '.';

const selectNavigationParams = createSelector(selectGoogleDrive, (gdrive) => gdrive.lists[consts.CONTEXTS.ASSETS].params);

export const selectNavigationFolderId = createSelector(selectNavigationParams, selectCurrentContext, (params, context) =>
  context === consts.CONTEXTS.ASSETS ? params.id : null
);

export const selectNavigationPreviousFolder = createSelector(selectNavigationParams, (params) => params.previousFolder);

export const selectNavigationDriveId = createSelector(selectNavigationParams, (params) => params.driveId);

export const selectNavigationKind = createSelector(selectNavigationParams, (params) => params.kind);

export const selectNavigationPath = createSelector(selectNavigationParams, (params) => params.path);

const selectListFolders = createSelector(selectGoogleDrive, selectCurrentContext, (gdrive, context) => gdrive.lists[context].folders);

export const selectFolders = createSelector(selectListFolders, (folders) => folders.data || []);

export const selectFiles = createSelector(selectListFiles, (files) => files.data || []);

export const selectSelectedFiles = createSelector(selectGoogleDrive, selectCurrentContext, (gdrive, context) => gdrive.lists[context].selected);

export const selectFilesCursor = createSelector(selectListFiles, (files) => files.cursor);

const selectFoldersStatus = createSelector(selectListFolders, (folders) => folders.status);

const selectFilesStatus = createSelector(selectListFiles, (files) => files.status);

export const selectFoldersCursor = createSelector(selectListFolders, (folders) => folders.cursor);

export const selectFoldersIsPending = createSelector(selectFoldersStatus, (status) => status === STATUSES.PENDING);

export const selectFoldersLoadingIsDone = createSelector(
  selectFoldersStatus,
  selectFoldersCursor,
  (status, cursor) => status === STATUSES.SUCCESS && !cursor
);

export const selectFilesIsPending = createSelector(selectFilesStatus, (status) => status === STATUSES.PENDING);

export const selectFilesIsInit = createSelector(selectFilesStatus, (status) => status === undefined);

export const selectIsLoading = createSelector(
  selectFoldersIsPending,
  selectFilesIsPending,
  selectFolders,
  selectFiles,
  (folderIsPending, filesIsPending, folders, files) => (folderIsPending && !folders.length) || (!files.length && filesIsPending && !folders.length)
);

export const selectIsNoResults = createSelector(
  selectFoldersStatus,
  selectFilesStatus,
  selectFolders,
  selectFiles,
  (foldersStatus, filesStatus, folders, files) =>
    (!foldersStatus || foldersStatus !== STATUSES.PENDING) && !folders.length && (!filesStatus || filesStatus !== STATUSES.PENDING) && !files.length
);

export const selectListRequestId = createSelector(selectGoogleDrive, (gdrive) => gdrive.lists.requestId);
